import Userback, { UserbackWidget } from "@userback/widget";

const USERBACK_ACCESS_TOKEN = "A-dcPt0AWvxCZjD5hMwgGF9xYyx";

type User = { id: string; info: { name?: string; email?: string } };
let userbackInstance: UserbackWidget | null = null;
let initialization: Promise<UserbackWidget> | null = null;
let currentUser: User | null = null;

export function getUserback(): UserbackWidget | null {
  return userbackInstance;
}

export function identifyUser(userId: string, userInfo: User["info"]): void {
  currentUser = { id: userId, info: userInfo };
  if (userbackInstance) {
    userbackInstance.identify(userId, userInfo);
    userbackInstance.show();
    return;
  }
  if (!initialization) {
    // Stay hidden until loading finishes and the session is still authenticated.
    initialization = Userback(USERBACK_ACCESS_TOKEN, { autohide: true });
    void initialization.then((userback) => {
      userbackInstance = userback;
      if (currentUser) {
        userback.identify(currentUser.id, currentUser.info);
        userback.show();
      } else {
        userback.hide();
      }
    }).catch((error) => {
      initialization = null;
      console.error("Failed to initialize Userback:", error);
    });
  }
}

export function clearUserIdentification(): void {
  currentUser = null;
  if (userbackInstance) {
    userbackInstance.hide();
    userbackInstance.identify("anonymous", {});
  }
}
